import * as CookieConsent from 'vanilla-cookieconsent';
import { setAnalyticsConsent } from './analytics';

function isAnalyticsAccepted() {
    return CookieConsent.acceptedCategory('analytics');
}

// The library calls onFirstConsent then onConsent when a visitor first chooses, onConsent
// alone on every later page load, and onChange when a saved choice is changed. Only the
// analytics choice can change, because Strictly Necessary is locked on.
// getOptions returns the latest { reload, measurementId }, so changed props are never stale.
export function createConsentHandlers(getOptions) {
    let isFirstConsentInProgress = false;

    return {
        onFirstConsent() {
            isFirstConsentInProgress = true;
            if (isAnalyticsAccepted()) {
                getOptions().reload();
            }
        },

        onConsent() {
            if (!isFirstConsentInProgress) {
                setAnalyticsConsent(getOptions().measurementId, isAnalyticsAccepted());
            }
            isFirstConsentInProgress = false;
        },

        onChange() {
            const { reload, measurementId } = getOptions();
            if (!isAnalyticsAccepted()) {
                setAnalyticsConsent(measurementId, false);
            }
            reload();
        },
    };
}
